import ENV from "../env";

const getStripeTicketingReport = async ({ eventId, from, to }) => {
  const params = new URLSearchParams({
    eventId,
    from: String(from),
    to: String(to),
  });

  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/ticketing-report?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(
      resData?.error?.raw?.message || resData?.error || "Unknown error while fetching Stripe report",
    );
  }

  return resData;
};

export default getStripeTicketingReport;
